module.exports = __webpack_public_path__ + "img/calendar-white.03bd5f65.svg";